import { render, staticRenderFns } from "./University.vue?vue&type=template&id=78a37390&scoped=true&"
import script from "./University.vue?vue&type=script&lang=js&"
export * from "./University.vue?vue&type=script&lang=js&"
import style0 from "./University.vue?vue&type=style&index=0&id=78a37390&prod&lang=scss&"
import style1 from "./University.vue?vue&type=style&index=1&id=78a37390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a37390",
  null
  
)

export default component.exports